import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, Image, Text, TextInput, Flex } from "@mantine/core";
import { IconMap } from "@tabler/icons-react";

import { PaginatedList } from "@components/shared";

export default function OrganizationList({
  items = null,
  requestInfo = {
    url: `/retrieve-organizations/`,
    data: {},
  },
  refresh,
}) {
  const [searchValue, setSearchValue] = useState("");

  const reqData = {
    ...requestInfo.data,
    search_value: searchValue,
    refresh,
  };

  return (
    <div>
      {requestInfo && items === null && (
        <TextInput
          placeholder="Search for an organization..."
          size="lg"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      )}
      <PaginatedList
        tableData={items}
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r) =>
          r.map((m) => ({
            ...m,
            link_url: `/organizations/${m.id}`,
          }))
        }
        displayFormatter={(item) => (
          <Card
            component={Link}
            to={item.original.link_url}
            key={item.original.id}
          >
            {item.original.image && (
              <Card.Section>
                <Image
                  src={item.original.image}
                  height={250}
                  alt={`${item.original.title} photo`}
                />
              </Card.Section>
            )}
            <Text fw={700}>{item.original.name}</Text>
            {item.original.city && (
              <Flex align="center" gap="xs">
                <IconMap size={16} />
                <Text size="sm">
                  {item.original.city}, {item.original.state_province}
                </Text>
              </Flex>
            )}
          </Card>
        )}
      />
    </div>
  );
}
